
import { Component, Vue, Watch } from 'vue-property-decorator'
import { apiShopCheckDetail, apiShopCheckAdd, apiShopCheckEdit } from '@/api/shop'
import { throttle } from '@/utils/util'
@Component
export default class ShopCheckEdit extends Vue {
  /** S Data **/

  identity: number | null = null; // 当前编辑用户的身份ID

  // 添加商城表单数据
  form: any = {
    name: '', // 名称
    shop_name: '', // 商户名称
    phone: '', // 手机号
    address: '', // 地址
    category: '', // 类目
    region: '', // 地区
    servicePhone: '', // 客服手机
    status: 0, // 状态
    url: '', // 登录地址
    account: '', // 账号
    password: '' // 密码
  };

  // 表单校验
  rules = {
    name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
    shop_name: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
    phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
    address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
    category: [{ required: true, message: '请输入类目', trigger: 'blur' }],
    region: [{ required: true, message: '请输入地区', trigger: 'blur' }],
    servicePhone: [{ required: true, message: '请输入客服手机', trigger: 'blur' }],
    url: [{ required: true, message: '请输入登录地址', trigger: 'blur' }],
    account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
    password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
  };

  /** E Data **/

  /** S Methods **/
  // 状态变化
  statusChange() {
    if (this.form.status !== 1) {
      this.form.url = '';
      this.form.account = '';
      this.form.password = '';
    }
  }

  // 点击表单提交
  onSubmit(formName: string) {
    // 验证表单格式是否正确
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return

      if (!this.identity) {
        this.handleShopCheckAdd()
      } else {
        this.handleShopCheckEdit()
      }
    })
  }

  // 添加商城
  async handleShopCheckAdd(): Promise<void> {
    await apiShopCheckAdd({ ...this.form })
    setTimeout(() => this.$router.go(-1), 500)
  }

  // 编辑商城
  async handleShopCheckEdit(): Promise<void> {
    await apiShopCheckEdit({ ...this.form, id: this.identity })
    setTimeout(() => this.$router.go(-1), 500)
  }

  // 获取详情
  async getShopCheckDetailFunc(): Promise<void> {
    const res: any = await apiShopCheckDetail({
      id: this.identity as number
    })
    Object.keys(res).map((key) => {
      if (res[key] === null || res[key] === undefined) return
      this.$set(this.form, key, res[key])
    })
    console.log(this.form)
  }
  /** E Methods **/

  /** S Life Cycle **/
  async created() {
    const query: any = this.$route.query

    // 编辑模式：初始化数据
    this.identity = +query.id
    if (+query.id) {
     await this.getShopCheckDetailFunc()
    }
    this.onSubmit = throttle(this.onSubmit, 1000)
  }
  /** E Life Cycle **/
}
